import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useBlacklists = () => {
  const { state: { blacklists = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'blacklists/list',
    params: { term: blacklists.term, offset: blacklists.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Blacklists',
      count: _.get(data, 'count', 0),
      loading: _.get(blacklists, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, blacklists]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'blacklists', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'blacklists', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({ type: 'blacklists', payload: { model: {}, formLoading: true }});
      let model = {};

      if (data.id) {
        const response = await api.get('blacklists/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'blacklists', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const remove = async (model, actions) => {
    try {
      dispatch({ type: 'blacklists', payload: { formLoading: true }});

      if (_.get(model, 'id')) {
        await api.delete('blacklists/remove', { params: { id: _.get(model, 'id') } });
      }
      showMessage('success', `Blacklist removida com sucesso`);
      dispatch({ type: 'blacklists', payload: { formLoading: false } });
      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'blacklists', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`blacklists/${path}`, model);
      mutate(data);
      showMessage('success', `Blacklist ${editing ? 'atualizada' : 'criada'} com sucesso`);
      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...blacklists,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      remove,
      createOrUpdate,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'blacklists', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default useBlacklists;
